import Activite from "./Activite.class";


/**
 * @classdesc Liste des activites d'un module
 * @kind class
 * @export
 * @prop {int} id_module - Id du module
 * @prop {array} list - Liste des activites
 * @class List_Activites
 */
export default class List_Activites {
    id_module;
    list = [];

    /**
     *  Initialise la liste des activites
     *
     * @constructs
     * @param id - Id du module
     * @memberof List_Activites
     */
    constructor(id) {
        this.id_module = id;
    }

    initialize_from_mainstore(activites) {
        for (let i = 0; i < activites.length; i++) {
            let activite = new Activite();
            activite.set(activites[i]);
            if (this.list.find(o => o.id == activite.id) == undefined) {
                this.list.push(activite);
            }
        }
    }


    add_from_transferable(transferable_inscription) {
        for (let i = 0; i < transferable_inscription.commande_options.length; i++) {
            let commande_option = transferable_inscription.commande_options[i];
            if (commande_option.type == 'activite') {
                for (let j = 0; j < this.list.length; j++) {
                    if (this.list[j].id == commande_option.id_item) {
                        this.list[j].quantite_souhaite = commande_option.quantite;
                    }
                }
            }
        }
    }

    toggle_from_dossard_bourse(dossard_bourse) {
        let options_in_dossard_bourse = dossard_bourse.options.filter(option => option.type == 'activite');
        for (let i = 0; i < options_in_dossard_bourse.length; i++) {
            let option = options_in_dossard_bourse[i];
            for (let j = 0; j < this.list.length; j++) {
                if (this.list[j].id == option.id_item) {
                    this.list[j].quantite_souhaite = option.quantite;
                    break;
                }
            }
        }
    }


    /**
     * Créer la liste des activites du module
     *
     * @param {array} data
     * @memberof List_Activites
     */
    set(data) {
        for (let i = 0; i < data.length; i++) {
            let activite = new Activite();
            activite.set(data[i]);
            this.list.push(activite);
        }
    }

    update_cart(vip_ins = null, lien_groupe = null) {
        let cart = { nb_articles: 0, prix: 0, prix_regulier: 0 };
        for (let i = 0; i < this.list.length; i++) {
            let item_cart = this.list[i].update_cart(vip_ins, lien_groupe);
            cart.nb_articles += parseInt(item_cart.nb_articles);
            cart.prix += parseFloat(item_cart.prix);
            cart.prix_regulier += parseFloat(item_cart.prix_regulier || item_cart.prix || 0);
        }
        this.cart = cart;
        return cart;
    }

    group_by(key) {
        let groups = [];
        for (let i = 0; i < this.list.length; i++) {

            let activite = this.list[i];
            let group = activite.get_metadata(key);
            if (group == false) {
                group = "Sans groupe";
            }
            let group_found = false;
            for (let j = 0; j < groups.length; j++) {
                if (groups[j].name == group) {
                    groups[j].list.push(activite);
                    group_found = true;
                    break;
                }
            }
            if (!group_found) {
                groups.push({ name: group, list: [activite] });
            }

        }
        return groups;
    }

    getSimplifiedData() {
        if (this.cart?.nb_articles == 0) return null;
        let infos = {};
        infos.prix = this?.cart?.prix;
        infos.list = [];
        for (let i = 0; i < this.list.length; i++) {
            const activite = this.list[i];
            let activite_infos = activite.getSimplifiedData();
            if (activite_infos) {
                infos.list.push(activite_infos);
            }
        }
        return infos;
    }

}
